// extracted by mini-css-extract-plugin
export default {"Box_0":"VisibleAndOverflowContainer-module__Box_0--cTFgm","space":"VisibleAndOverflowContainer-module__space--BaowS"};